export type ViewportTier = "mobile" | "tablet" | "desktop";

export const viewportBreakpoints = {
  mobile: 768,
  desktop: 1180
} as const;

export function getViewportTier(width: number): ViewportTier {
  if (width < viewportBreakpoints.mobile) {
    return "mobile";
  }

  if (width < viewportBreakpoints.desktop) {
    return "tablet";
  }

  return "desktop";
}

export function isMobileViewport(tier: ViewportTier) {
  return tier === "mobile";
}

export function isTabletViewport(tier: ViewportTier) {
  return tier === "tablet";
}

export function isDesktopViewport(tier: ViewportTier) {
  return tier === "desktop";
}

export function isCompactViewport(tier: ViewportTier) {
  return tier !== "desktop";
}
